import { instance as axiosInstance } from "./axiosInstance";

export const getQueryData = async (url: string, headers: any, params?: any) => {
  try {
    const response = await axiosInstance().get(url, headers);
    return response?.data;
  } catch (error) {
    console.log('GET QUERY ERROR: ', error);
    return error;
  }
};

export const postQueryData = async ( url: string, headers:any, params?:any ) => {
  try {
    const response = await axiosInstance().post(url,params,headers );
    return response?.data;
  } catch (error: any) {
    console.log('POST QUERY ERROR: ', error);
    throw new Error(error.status);
  }
};

export const deleteQueryData = async ({ url, params, headers }: any) => {
  try {
    const response = await axiosInstance().delete(url, { params, ...headers });
    return response?.data;
  } catch (error: any) {
    console.log('DELETE QUERY ERROR: ', error);
    throw new Error(error.status);
  }
};

export const updateQueryData = async ({ url, params, headers }: any) => {
  try {
    const response = await axiosInstance().put(url, params, { headers });
    return response?.data;
  } catch (error: any) {
    console.log('UPDATE QUERY ERROR: ', error.response || error.message || error);
    throw new Error(error.status);
  }
};
